<template>
    <transition name="slide-fade">
        <div id="free-starbuck-modal" class="modal" data-cy="modal_history_starbuck" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full h-full bg-starbucks">
                    <div class="pr-5 absolute top-90px">
                        <div class="w-fit ml-auto pb-4 font-medium text-a-green-03613d text-left">
                            <div class="text-40" data-cy="text_history_starbuck_title">
                                {{lbl.history.starbuck.title}}
                            </div>
                            <div class="text-22" data-cy="text_history_starbuck_price">
                                {{FilterStringFormat(lbl.history.starbuck.price, purchase.originalPrice)}}
                            </div>
                            <div class="italic text-10" data-cy="text_history_starbuck_remark">
                                {{lbl.history.starbuck.remark}}
                            </div>
                        </div>
                        <div class="mr-2 mb-5 w-fit ml-auto">
                            <VueQrcode :value="purchase.serial" :options="qrOption" data-cy="img_history_starbuck_qr"></VueQrcode>
                            <div class="text-8 text-a-gray-666666 text-center pt-1" data-cy="text_history_starbuck_serial">
                                {{purchase.serial}}
                            </div>
                        </div>
                        <div class="text-8 text-a-black-000000">
                            <div data-cy="text_history_starbuck_privilege" v-html="getPrivilegeMsg()"></div>
                            <div data-cy="text_history_starbuck_condition" v-html="lbl.history.starbuck.condition"></div>
                        </div>
                    </div>
                    <div class="w-full m-auto bottom-0 absolute">
                        <button class="w-full bg-a-green-03613d text-16 text-center text-a-white-ffffff py-3.5"
                            data-cy="btn_history_starbuck_close"
                            @click="clickOk()">
                            {{btnOk}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//lib
import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {
    name: "FreeStarbuckModal",
    mixins: [LocaleMixin],
    components: {
        VueQrcode,
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            bgImg: '',
            title: '',
            message: '',
            btnOk: '',
            busModal: null,

            purchase: null,
            serialNumber: null,

            qrOption: {
                width: 105,
                height: 105,
                margin: 3,
            },
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            this.bgImg = config.bgImg;
            this.purchase = config.purchase;
            this.serialNumber = config.serialNumber;
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.close;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        getPrivilegeMsg: function(){
            return this.localeCode == 1033 ? this.purchase.privilegeMessageEn : this.purchase.privilegeMessage;
        },
    },
}
</script>
<style lang="scss">
    @import "@/style/modal.scss";
    @import "@/style/base/image.scss";
#free-starbuck-modal{
    &.modal {
        @extend %modal;
        height: 100vh;
        .modal-content{
            position: absolute;
            width: 100%;
            height: 100%;
            max-width: 500px;
            background-size: contain;
            .bg-starbucks{
                @include boxRatio($ratio: 66.66%);
                background-image: url(../../../../assets/image/img-history-starbuck.jpg);
                background-repeat: no-repeat;
                background-size: contain;
                background-position: top center;
            }

        }
    }
}
</style>
